import type { FaireProductEntity } from "../../entity_types/product";

export const p_6j9k5wtqaq: FaireProductEntity = {
  token: "p_6j9k5wtqaq",
  type: "product",
  name: "Love Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/3bf588e650b4cc4c79ab0baf09e8bc04148c55c88c45c8263ba1fe09b590a28b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b5231fcb65091ebc2320cfade8d3071ae015f9105c720e9c816802b8b6408fef.jpeg",
    "https://cdn.faire.com/fastly/3b0dca2d4cf949177a83fd57f1ab888852fa4961490bfa6d257544e02696c0bc.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/b53f76ae0f3414cec0a10f0549224b42cbe543abf2de2af8cb02bb976bd4bbf9.jpeg",
    "https://cdn.faire.com/fastly/77851e27052408109c10fc81252ee5e08bdfc61e68a95a01cfec658cdbd55b15.jpeg"
  ],
  priceDollars: 6.75,
  description: "Finally, some socks that say LOVE so you don't have to all the time.\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance.\n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:36:29.326Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
